import { useCallback } from 'react';
import { nanoid } from 'nanoid';
import { usePreference } from '@frontend/user-preferences';

interface Searches {
  id: string;
  term: string;
  feature: string;
}

interface SearchesState {
  searches: Searches[];
  addSearch: (term: string, feature: string) => void;
  deleteSearch: (index: number) => void;
}

export const useGlobalRecentSearches = (): SearchesState => {
  const [searches, setSearches] = usePreference('GlobalSearchRecentSearches');

  const addSearch = useCallback(
    (term: string, feature: string) => {
      const newSearch = { id: nanoid(10), term, feature };
      const existingSearchIndex = searches?.findIndex((search) => search.term === term && search.feature === feature);

      let updatedSearches;
      if (existingSearchIndex !== -1) {
        updatedSearches = searches?.filter((_, i) => i !== existingSearchIndex);
      } else {
        updatedSearches = searches;
      }

      updatedSearches = [newSearch, ...(updatedSearches || [])].slice(0, 5);
      setSearches(updatedSearches);
    },
    [searches]
  );

  const deleteSearch = useCallback(
    (index: number) => {
      const updatedSearches = searches?.filter((_, i) => i !== index);
      setSearches(updatedSearches);
    },
    [searches]
  );

  return { searches, addSearch, deleteSearch };
};
